/** Foreground poll interval for session-scoped pollers (status tracking, notification counts). */
export const FOREGROUND_POLL_MS = 30_000;
/** Poll interval while the tab is hidden; also the cap for error backoff. */
export const HIDDEN_POLL_MS = 300_000;

export interface PollState {
	visible: boolean;
	/** HTTP status of the last attempt; null for a network failure; undefined before the first attempt. */
	lastStatus: number | null | undefined;
	consecutiveErrors: number;
}

/**
 * Decide when the next poll should run. `null` means stop polling: the session
 * is gone (401) or the user is not allowed to see this resource (403), and
 * retrying would only generate more failed requests.
 */
export function nextPollDelayMs(state: PollState): number | null {
	if (state.lastStatus === 401 || state.lastStatus === 403) return null;
	if (!state.visible) return HIDDEN_POLL_MS;

	const serverOrNetworkError = state.lastStatus === null || (state.lastStatus ?? 0) >= 500;
	if (serverOrNetworkError && state.consecutiveErrors > 0) {
		return Math.min(FOREGROUND_POLL_MS * 2 ** state.consecutiveErrors, HIDDEN_POLL_MS);
	}
	return FOREGROUND_POLL_MS;
}
